import { useMemo } from 'react';
import { IntlShape, useIntl } from 'react-intl';

import { IPartner } from '@/modules/partner/model';
import { CountryCode, TCountryCodes } from '@/shared/models/country-code';

import { isCompany, isSelfEmployed } from '../company';

import { messages } from './messages';

const useCompanyTitles = (intl: IntlShape): ['ein' | 'dbaName' | 'licenseNumber', string][] =>
  useMemo(
    () => [
      ['ein', intl.formatMessage(messages.einTitle)],
      ['dbaName', intl.formatMessage(messages.dbaTitle)],
      ['licenseNumber', intl.formatMessage(messages.tlcTitle)],
    ],
    [intl],
  );

const useSelfEmployedTitles = (intl: IntlShape): ['ssn', string][] =>
  useMemo(() => [['ssn', intl.formatMessage(messages.ssnTitle)]], [intl]);

export const useCompanyInfo = ({
  region,
  partner,
}: {
  region: TCountryCodes;
  partner: IPartner;
}) => {
  const intl = useIntl();

  const usCompanyTitles = useCompanyTitles(intl);

  if (region === CountryCode.UnitedStates && isCompany(partner)) {
    return usCompanyTitles;
  }

  return [];
};

export const useSelfEmployedInfo = ({
  region,
  partner,
}: {
  region: TCountryCodes;
  partner: IPartner;
}) => {
  const intl = useIntl();

  const usSelfEmployedTitles = useSelfEmployedTitles(intl);

  if (region === CountryCode.UnitedStates && isSelfEmployed(partner)) {
    return usSelfEmployedTitles;
  }

  return [];
};
